/**
 * Where each uploaded file sat in the folder the writer uploaded.
 *
 * Clients often deliver sources in folders that mirror the CTD (Module 3 →
 * 3.2.P → 3.2.P.5 …) or a TMF structure. The library itself is flat, so the
 * path is sent with each upload and kept server-side as the document's folder
 * tag, which the drafting agents list and filter by (a strong hint, not proof).
 *
 * A dropped folder's files come from the entries API, whose ``File`` objects
 * carry no path — ``collectDroppedFiles`` records it here. A folder-picker
 * file carries its own ``webkitRelativePath``. ``uploadFile`` reads both, so
 * no caller in between has to thread the path through.
 */

const recorded = new WeakMap<File, string>();

/** Remember ``file``'s path inside the uploaded folder (e.g. "Module 3/3.2.P/Spec.pdf"). */
export function recordRelativePath(file: File, relativePath: string): void {
  const clean = relativePath.replace(/^\/+/, "");
  if (clean) recorded.set(file, clean);
}

/** The file's path inside the uploaded folder, or "" for a loose file. */
export function relativePathOf(file: File): string {
  const fromDrop = recorded.get(file);
  if (fromDrop) return fromDrop;
  const fromPicker = (file as File & { webkitRelativePath?: string }).webkitRelativePath;
  return typeof fromPicker === "string" ? fromPicker : "";
}
